import { type BoxProps } from '@ironhack/design-system2/components/box';
import { type ReactElement, Suspense } from 'react';

import { ClientOnly } from '@/app/components/client/client-only';
import { VideoThumbnail } from './video-thumbnail';
import { VideoPlayer, type VideoPlayerData } from './video-player';

type Props = {
  data: VideoPlayerData;
} & BoxProps;

export const CmsVideo = (props: Props): ReactElement => {
  const { data, ...boxProps } = props;

  const fallback = <VideoThumbnail data={data} />;

  return (
    <Suspense fallback={fallback}>
      <ClientOnly fallback={fallback}>
        <VideoPlayer data={data} fallback={fallback} {...boxProps} />
      </ClientOnly>
    </Suspense>
  );
};
